import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { completeReimbursementReport } from "~/providers/api";
import { ReimbursementReportData } from "~/providers/utils/types/consultation";

export const useCompleteReimbursementReport = (consultationId?: string) => {
  const queryClient = useQueryClient();
  const { mutate: completeReimbursementReportMutation, isPending } =
    useMutation({
      mutationFn: (reportData: ReimbursementReportData) =>
        completeReimbursementReport({ data: reportData }, consultationId),
      onError: () =>
        toast.error(
          "We shoot trouble completing the progress note, if the issue persists please reload the page!",
        ),
      onSuccess: async () => {
        toast.success("Progress note completed successfully!");
        await queryClient.invalidateQueries({
          queryKey: ["getReimbursementReport", consultationId],
        });
      },
    });

  return { completeReimbursementReportMutation, isPending };
};
